// extracted by mini-css-extract-plugin
export var dropdownButton = "_30-0";
export var fullWidthDropdownButton = "_30-1";
export var icon = "_30-3";
export var iconPlaceholder = "_30-2";
export var menuItemRow = "_30-9";
export var separator = "_30-e";
export var shortcutContainer = "_30-7";
export var shortcutContainerFilled = "_30-8";
export var shortcutIconLg = "_30-6";
export var shortcutIconMd = "_30-5";
export var shortcutIconSm = "_30-4";
export var submenuChevron = "_30-d";
export var submenuDropdown = "_30-a";
export var submenuTriggerRow = "_30-b";
export var submenuTriggerRowOpen = "_30-c";